import { useCallback, useEffect, useRef } from "react";

/** Keep hover UI open while moving between nearby targets (e.g. button → overlay). */
export function useDeferredPointerHover(closeDelayMs = 180) {
  const closeTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const cancelClose = useCallback(() => {
    if (closeTimerRef.current != null) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
  }, []);

  const scheduleClose = useCallback(
    (onClose: () => void) => {
      cancelClose();
      closeTimerRef.current = setTimeout(() => {
        closeTimerRef.current = null;
        onClose();
      }, closeDelayMs);
    },
    [cancelClose, closeDelayMs]
  );

  useEffect(() => () => cancelClose(), [cancelClose]);

  return { cancelClose, scheduleClose };
}
